<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modalcito">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content modal-sm">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>{{obj.xtitle}}</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <p> {{obj.xbody}} </p>
                <input type="number" name="codigo" class="form-control" v-model="codigo">
            </div>
            
            <Alertas 
                ref="alertar" 
                v-bind:msgSuccess="'La asignacion de codigo se realizo satisfactoriamente.'"
                v-bind:msgLoading="'Aplicando...'"
                />
            <div class="modal-footer">
                <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>

        
    </div>
</template>

<script>
import gql from 'graphql-tag'
import Alertas from '@/components/AAlertas.vue'
    export default {
        props: {
            obj:{ // {xid:Number,xidpro:Number,xtitle:String,xbody:String,xsql:Object}
                type: Object,
                required: true
            },
        },
        data(){
            return{
                activo: true,
                codigo: null,
            }
        },
        watch:{
            'obj.xid': function(){ 
                if( this.obj.xid == null ) return;
                this.$refs.alertar.reset(); 
                this.activo = true;
            },
            'obj':function(){ 
                this.$refs.alertar.reset();
                this.activo = true;
            }
        },
        components:{Alertas},
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            }, 
            submit(){
                // window.console.log( "ZZZZ ",this.obj.xsql,typeof(this.obj.xsql) );
                var vue = this;
                var tag = gql`mutation{asignarCourseProgramaModulo(input:{idmodulo:${this.obj.xid},idprograma:${this.obj.xidpro},course_id:${this.codigo}}){errors{message}}}`;
                vue.$refs.alertar.cargando();
                vue.activo = false;
                window.console.log( tag )

                this.$apollo.mutate({
                    mutation: tag,
                }).then((/*data*/) => {
                    // window.console.log(data);
                    vue.$refs.alertar.success();
                    this.$emit('exito');
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            }
        },
    
    }
</script>